import type { SVGProps } from 'react';

interface FlashIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const FlashIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & FlashIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 21"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <circle cx={10} cy={10.417} fill="#F8F8F8" r={7.5} />
    <path
      d="M20 10.417a10 10 0 1 1-20 0 10 10 0 0 1 20 0m-8.13-6.364H9.266a.91.91 0 0 0-.85.59l-2.046 5.454a.91.91 0 0 0 .853 1.229h1.414l-1.405 4.212a.942.942 0 0 0 1.684.813l4.772-7.343a.855.855 0 0 0-.714-1.319h-1.155l.904-2.409a.91.91 0 0 0-.851-1.227"
      fill="#4FA9FF"
    />
  </svg>
);
